import React from 'react';
import { Play } from "lucide-react";

interface VideoCardProps {
    title: string;
    videoId: string;
    description?: string;
}

const VideoCard = ({ title, videoId, description }: VideoCardProps) => {
    return (
        <div className="group overflow-hidden transform transition-all duration-500 hover:scale-[1.02] bg-white/5 backdrop-blur-sm border border-white/5 hover:border-market-teal/20 hover:shadow-[0_0_30px_rgba(74,222,128,0.15)] w-full">
            <div className="aspect-video relative overflow-hidden h-[140px] sm:h-[160px]">
                <img
                    src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
                    alt={title}
                    className="w-full h-full object-cover transform transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <button className="w-12 h-12 rounded-full flex items-center justify-center bg-market-teal text-black transform scale-75 group-hover:scale-100 transition-all duration-300">
                        <Play className="w-6 h-6 ml-1" />
                    </button>
                </div>
            </div>
            <div className="p-4 space-y-2">
                <h3 className="text-lg font-semibold text-white/90 group-hover:text-market-teal border-market-teal transition-colors">
                    {title}
                </h3>
                {description && (
                    <p className="text-sm text-gray-400">{description}</p>
                )}
            </div>
        </div>
    );
};

export default VideoCard;